<template>
    <v-container fluid>
        <v-row align="center" justify="center" v-if="permissable">
            <v-col cols="12" sm="10" lg="9" xl="7" class="d-flex flex-row flex-wrap justify-space-between align-center">
                <h1 class="platformName">{{ pageName }}</h1>
                <p class="platformSubtitle">{{ pageSubtitle }}</p>
            </v-col>
        </v-row>

        <v-row align="center" justify="center" v-else>
            <v-col cols="12" sm="10" lg="9" xl="7" class="d-flex flex-row flex-wrap justify-space-between align-center">
                <v-card>
                    <v-card-title><h1>Premium Content</h1></v-card-title>
                    <v-card-text>
                        <p>You've reached a premium page. If you'd like access to this page and additional premium features, contact support@swyftpages.com.</p>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <Training v-if="pageName === 'Training' || pageName === 'Tutorials'" :cards="pageCards"/>

        <v-row align="start"
               justify="center"
               v-else-if="permissable"
        >
            <v-col cols="12" sm="10" lg="9" xl="7"
            >
                <Card v-for="(card, id) in pageCards"
                      :id="card.id"
                      :key="card.name+id"
                      class="mb-10"
                />
            </v-col>
        </v-row>

        <v-row v-if="pageName === 'Support'"
               align="start"
               justify="center"
        >
            <v-col cols="12" sm="10" lg="9" xl="7"
            >
                <Faq></Faq>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>

import { mapState, mapActions } from 'vuex';
import Card from './Card/Card';
import Faq from '@/components/Faq';
import Training from '@/components/Training';

export default {
    components: { Training, Faq, Card, /* Overlay */ },

    computed: {
        ...mapState('page',
            [
                'pageName',
                'pageSlug',
                'pageSubtitle',
                'pageCards',
                'pageData',
                'permissable'
            ]
        )
    },

    watch: {
        '$route.path'() {
            this.getPageData();
        }
    },

    data() {
        return {
            panel: [0,1,2,3,4,5,6,7,8,9,10],
        };
    },

    mounted() {
        this.getPageData();
    },

    methods: {
        ...mapActions({
            getPageData: 'page/getPageData'
        })
    }
};
</script>
